import getInstanceSettings from './getInstanceSettings';

const getInstanceSetting = async (
  app: string,
  key: string
): Promise<string | null> => {
  const response = await getInstanceSettings();
  const settings = response?.data ?? [];
  const match = settings.find(
    (s: { app: string; key: string; value: string }) =>
      s.app === app && s.key === key
  );
  console.log(
    `[getInstanceSetting] looking for app="${app}" key="${key}". ` +
      `Available (app/key):`,
    settings.map((s: { app: string; key: string }) => `${s.app}/${s.key}`),
    '→ match:',
    match ?? null
  );
  return match?.value ?? null;
};

export default getInstanceSetting;
